import AppConstants from 'constants/AppConstants';

export function getTripleseatOAuthUrl(): ApiAction<string> {
  return {
    TockApi: {
      getProto: '/tripleseat/oauth/generate-url',
      type: AppConstants.TRIPLESEAT_OAUTH_URL,
    },
  };
}

/**
 * Fetch a Square OAuth URL with our app id, permissions and a CSRF token as parameters
 */
export function getSquareOAuthURL(): ApiAction<string> {
  return {
    TockApi: {
      getProto: '/square/oauth/generate-url',
      type: AppConstants.SQUARE_OAUTH_URL,
    },
  };
}
